/* Заглушки. Данные выдуманы, но согласованы: все сводки считаются из одного
   набора пространств и одного ряда ежедневных событий, поэтому суммы сходятся.
   Ответы имеют ровно ту форму, которую ждём от бэкенда (spec.md §6) —
   этот файл заодно служит контрактом для серверной части. */

const rnd = ((s) => () => (s = (s * 16807) % 2147483647) / 2147483647)(42);
const pick = (a) => a[Math.floor(rnd() * a.length)];
const irnd = (a, b) => a + Math.floor(rnd() * (b - a + 1));
const DAY = 86400000;
const NOW = new Date();
const TODAY = new Date(NOW.getFullYear(), NOW.getMonth(), NOW.getDate());
const iso = (d) => new Date(d).toISOString();
const wait = (v, ms = 220) => new Promise((r) => setTimeout(() => r(v), ms));

/* ---------- тарифы ----------
   Их может быть сколько угодно, и часть работает, не будучи на витрине. */
const PLANS = [
  { id: 1, name: 'База', price: 999, users: 2, spaceMb: 10 * 1024, projects: 3, trialDays: 30, published: true },
  { id: 2, name: 'ПРО', price: 4999, users: 5, spaceMb: 50 * 1024, projects: 10, trialDays: 30, published: true },
  { id: 3, name: 'ПРО-2', price: 4999, users: 5, spaceMb: 100 * 1024, projects: 10, trialDays: 30, published: false,
    hiddenNote: 'закрытый, по прямой ссылке на оплату' },
  { id: 4, name: 'Солидность 100%', price: 9999, users: 25, spaceMb: 100 * 1024, projects: 0, trialDays: 14, published: true },
  { id: 5, name: 'Партнёрский', price: 0, users: 5, spaceMb: 50 * 1024, projects: 10, trialDays: 0, published: false,
    hiddenNote: '2 месяца бесплатно за публичный пост' },
];
const planByName = (n) => PLANS.find((p) => p.name === n);

/* ---------- пространства ---------- */
const A = ['Красный', 'Северный', 'Первый', 'Тихий', 'Общий', 'Длинный', 'Чёрный', 'Новый', 'Ясный', 'Дикий'];
const B = ['кадр', 'монтаж', 'план', 'дубль', 'свет', 'цех', 'стык', 'титр', 'звук', 'хрон'];
const C = ['Медиа', 'Продакшн', 'Студия', 'Филмз', 'Пикчерз', 'Лаб', 'Воркс'];
const translit = (s) =>
  s.toLowerCase().replace(/[а-яё]/g, (c) => ({ а:'a',б:'b',в:'v',г:'g',д:'d',е:'e',ё:'e',ж:'zh',з:'z',и:'i',й:'y',к:'k',л:'l',м:'m',н:'n',о:'o',п:'p',р:'r',с:'s',т:'t',у:'u',ф:'f',х:'h',ц:'c',ч:'ch',ш:'sh',щ:'sch',ъ:'',ы:'y',ь:'',э:'e',ю:'yu',я:'ya' }[c] || c)).replace(/[^a-z0-9]/g, '');

const ORGS = [];
for (let i = 0; i < 63; i++) {
  const title = pick(A) + ' ' + pick(B) + (rnd() > 0.55 ? ' ' + pick(C) : '');
  const r = rnd();
  const plan = planByName(r > 0.95 ? 'Партнёрский' : r > 0.86 ? 'Солидность 100%' : r > 0.76 ? 'ПРО-2' : r > 0.4 ? 'ПРО' : 'База');
  const s = rnd();
  const status = s > 0.7 ? 'ACTIVE' : s > 0.4 ? 'TRIALING' : s > 0.28 ? 'UNPAID' : s > 0.2 ? 'EXPIRED' : s > 0.16 ? 'RETENTION' : 'ACTIVE';
  const created = new Date(+TODAY - irnd(3, 330) * DAY);
  const alive = status === 'ACTIVE' || status === 'TRIALING';
  const extraSeats = plan.price && plan.name !== 'База' && rnd() > 0.82 ? irnd(1, 4) : 0;
  const extraSpace10 = plan.price && plan.name !== 'База' && rnd() > 0.85 ? irnd(1, 5) : 0;
  const membersLimit = plan.users + extraSeats;
  const members = Math.max(1, Math.min(membersLimit, irnd(1, plan.users + 2)));
  const spaceLimitMb = plan.spaceMb + extraSpace10 * 10 * 1024;
  const usedMb = Math.round(spaceLimitMb * Math.min(1.02, (alive ? rnd() ** 0.8 : rnd() * 0.5) * (rnd() > 0.9 ? 1.25 : 1)));
  const projectsLimit = plan.projects || 0;
  const projects = Math.max(1, Math.min(projectsLimit || 26, irnd(1, projectsLimit || 26)));
  const videos = Math.round(usedMb / irnd(420, 1400)) + projects;
  const durationSec = videos * irnd(90, 900);
  const comments = Math.round(videos * irnd(4, 34) * (alive ? 1 : 0.4));
  const annual = plan.price > 0 && rnd() > 0.78;
  const base = annual ? Math.round((plan.price * 12 * 0.85) / 12) : plan.price;
  const monthlyRevenue = status === 'ACTIVE' ? base + extraSeats * 999 + extraSpace10 * 299 : 0;
  const slug = translit(title).slice(0, 12);
  const owners = [slug + '@' + pick(['mail.ru', 'gmail.com', 'yandex.ru', 'studio.ru'])];
  if (rnd() > 0.85) owners.push('buh.' + slug + '@yandex.ru');

  // Часть активных подписок выдана вручную: платежей по ним не было.
  const paidCount = status === 'ACTIVE' && plan.price ? (rnd() > 0.25 ? irnd(1, 12) : 0) : 0;

  ORGS.push({
    paidCount,
    id: 1000 + i, title, createdAt: iso(created), owners,
    plan: { id: plan.id, name: plan.name, published: plan.published },
    subscription: {
      status, annual,
      trialEndDate: status === 'TRIALING' ? iso(new Date(+TODAY + irnd(0, 29) * DAY)) : null,
      renewAt: status === 'ACTIVE' && plan.price ? iso(new Date(+TODAY + irnd(1, annual ? 300 : 30) * DAY)) : null,
      trialStartDate: iso(created),
      converted: status === 'ACTIVE' ? true : ['UNPAID', 'EXPIRED', 'RETENTION'].includes(status) ? false : null,
    },
    retention: status === 'RETENTION' ? { status: 'PENDING_DELETION', deadlineAt: iso(new Date(+TODAY + irnd(1, 15) * DAY)) } : null,
    usage: [
      { code: 'AVAILABLE_USER_COUNT', used: members, max: membersLimit, unlimited: false, updating: false },
      { code: 'AVAILABLE_SPACE_MB', used: usedMb, max: spaceLimitMb, unlimited: false, updating: rnd() > 0.96 },
      { code: 'AVAILABLE_PROJECT_COUNT', used: projects, max: projectsLimit || null, unlimited: !projectsLimit, updating: false },
    ],
    members: { active: members, pending: rnd() > 0.85 ? 1 : 0 },
    projects, projectsLimit, videos, durationSec, comments,
    addons: { seats: extraSeats, space10: extraSpace10 },
    monthlyRevenue,
    lastActivityAt: iso(new Date(+TODAY - (alive ? irnd(0, 9) : irnd(10, 90)) * DAY)),
  });
}
const use = (o, code) => o.usage.find((u) => u.code === code) || { used: 0, max: 0 };
const fill = (o) => { const u = use(o, 'AVAILABLE_SPACE_MB'); return u.max ? u.used / u.max : 0; };
const isLive = (o) => ['ACTIVE', 'TRIALING'].includes(o.subscription.status);
const isPaying = (o) => o.subscription.status === 'ACTIVE' && o.monthlyRevenue > 0 && o.paidCount > 0;
const isGranted = (o) => o.subscription.status === 'ACTIVE' && o.monthlyRevenue > 0 && !o.paidCount;

/* ---------- люди ---------- */
const NAMES = [['Аня','Смирнова'],['Олег','Крылов'],['Марина','Гусева'],['Пётр','Ильин'],['Настя','Рогова'],['Дима','Волков'],['Лена','Соколова'],['Кирилл','Зайцев'],['Саша','Панов'],['Вера','Титова'],['Игорь','Мухин'],['Юля','Белова'],['Тимур','Рахимов'],['Женя','Кац'],['Артём','Седов']];
const USERS = [];
let uid = 5000;
ORGS.forEach((o) => {
  for (let i = 0; i < o.members.active; i++) {
    const [first, last] = pick(NAMES);
    USERS.push({
      id: uid++, firstName: first, lastName: last,
      email: translit(first)[0] + '.' + translit(last) + irnd(1, 99) + '@' + pick(['gmail.com', 'yandex.ru', 'mail.ru', 'list.ru']),
      blocked: rnd() > 0.975,
      blockReason: null,
      organizations: [{ id: o.id, title: o.title, role: i === 0 ? 'OWNER' : 'EDITOR', roleStatus: rnd() > 0.92 ? 'PENDING' : 'ACTIVE' }],
      createdAt: iso(new Date(+new Date(o.createdAt) + irnd(0, 40) * DAY)),
      lastSeenAt: iso(new Date(+TODAY - irnd(0, 60) * DAY)),
      trialUsedAt: rnd() > 0.35 ? iso(new Date(+TODAY - irnd(30, 300) * DAY)) : null,
      comments: irnd(0, Math.max(1, Math.round(o.comments / o.members.active))),
    });
  }
});
USERS.filter(() => rnd() > 0.88).slice(0, 24).forEach((u) => {
  const other = pick(ORGS);
  if (other.id !== u.organizations[0].id)
    u.organizations.push({ id: other.id, title: other.title, role: 'EDITOR', roleStatus: 'ACTIVE' });
});

/* ---------- ежедневные события ---------- */
const SERIES = [];
for (let i = 399; i >= 0; i--) {
  const date = new Date(+TODAY - i * DAY);
  const dow = date.getDay();
  const growth = (400 - i) / 400;
  const week = dow === 0 || dow === 6 ? 0.34 : 1;
  const noise = 0.75 + rnd() * 0.5;
  const videos = Math.round((2 + growth * 24) * week * noise);
  SERIES.push({
    date,
    comments: Math.round((22 + growth * 210) * week * noise),
    videos,
    durationSec: videos * irnd(120, 780),
    users: Math.round((0.4 + growth * 3.4) * week * noise),
    workspaces: rnd() < 0.1 + growth * 0.55 ? 1 : 0,
    trials: rnd() < 0.08 + growth * 0.45 ? 1 : 0,
    payments: Math.round((0.2 + growth * 2.1) * week * noise * (rnd() > 0.82 ? 2 : 1)),
  });
}
/* Сегодняшний день неполный — он всегда считается живым запросом, §5.1 ТЗ. */
const todayPartial = () => {
  const share = (Date.now() - +TODAY) / DAY;
  const last = SERIES[SERIES.length - 1];
  return { ...last, comments: Math.round(last.comments * share), videos: Math.round(last.videos * share),
    durationSec: Math.round(last.durationSec * share), users: Math.round(last.users * share), partial: true };
};
const rangeDays = (days) => [...SERIES.slice(-days, -1), todayPartial()];
const prevDays = (days) => SERIES.slice(-days * 2, -days);
const sum = (rows, key) => rows.reduce((a, r) => a + r[key], 0);

/* Ниже — ответы ровно той формы, что приходит с сервера
   (см. admin/panel dashboard DTO в бэкенде). Если формат разойдётся,
   экраны сломаются одинаково и в заглушках, и на живых данных. */

const MB = 1024 * 1024;
const money = (o) => (o.subscription.status === 'ACTIVE' ? o.monthlyRevenue : 0);

/** Одно пространство в том виде, в каком его отдаёт сервер. */
function workspaceView(o, withTeam = false) {
  const view = {
    id: o.id,
    title: o.title,
    createdAt: o.createdAt,
    owners: o.owners,
    plan: o.plan,
    subscription: {
      id: o.id,
      status: o.subscription.status,
      startDate: o.createdAt.slice(0, 10),
      endDate: o.subscription.renewAt ? o.subscription.renewAt.slice(0, 10) : null,
      trialStartDate: o.subscription.trialStartDate ? o.subscription.trialStartDate.slice(0, 10) : null,
      trialEndDate: o.subscription.trialEndDate ? o.subscription.trialEndDate.slice(0, 10) : null,
      autoRenew: true,
      annual: o.subscription.annual,
    },
    retention: o.retention,
    usage: o.usage,
    members: { active: o.members.active, pending: o.members.pending },
    projects: o.projects,
    videos: o.videos,
    sizeBytes: Math.round(use(o, 'AVAILABLE_SPACE_MB').used * MB),
    durationSec: o.durationSec,
    comments: o.comments,
    monthlyRevenue: money(o),
    addonsMonthly: o.subscription.status === 'ACTIVE'
      ? o.addons.seats * 999 + o.addons.space10 * 299
      : 0,
    lastActivityAt: o.lastActivityAt,
    payments: {
      count: o.paidCount,
      total: o.paidCount * (o.monthlyRevenue || 0),
      lastAt: o.paidCount ? o.lastActivityAt : null,
    },
  };
  if (withTeam) {
    view.team = USERS.filter((u) => u.organizations.some((r) => r.id === o.id)).map((u) => {
      const role = u.organizations.find((r) => r.id === o.id);
      return {
        id: u.id, email: u.email, firstName: u.firstName, lastName: u.lastName,
        role: role.role, status: role.roleStatus, blocked: u.blocked,
      };
    });
  }
  return view;
}

function userView(u) {
  return {
    id: u.id,
    email: u.email,
    firstName: u.firstName,
    lastName: u.lastName,
    blocked: u.blocked,
    blockReason: null,
    globalRole: null,
    createdAt: u.createdAt,
    trialUsedAt: u.trialUsedAt,
    comments: u.comments,
    lastActivityAt: u.lastSeenAt,
    organizations: u.organizations.map((r) => ({
      id: r.id, title: r.title, role: r.role, status: r.roleStatus,
    })),
  };
}

export const api = {
  auth: {
    /* В режиме заглушек «вход» просто помечает сессию: настоящий вход —
       это переход на Keycloak, которого локально нет. */
    login() {
      sessionStorage.setItem('mockAdmin', 'admin@7cut.video');
      window.location.reload();
    },
    async me() {
      const email = sessionStorage.getItem('mockAdmin');
      if (!email) { const e = new Error('Не авторизован'); e.status = 401; throw e; }
      return wait({ email, name: 'Администратор', role: 'ADMIN', isAdmin: true }, 60);
    },
    async logout() { sessionStorage.removeItem('mockAdmin'); return wait(null, 60); },
  },

  async summary({ days = 30 } = {}) {
    const cur = rangeDays(days);
    const prev = prevDays(days);
    const live = ORGS.filter(isLive);
    const pay = ORGS.filter(isPaying);
    const usedBytes = live.reduce((sum, o) => sum + use(o, 'AVAILABLE_SPACE_MB').used * MB, 0);
    const limitBytes = live.reduce((sum, o) => sum + use(o, 'AVAILABLE_SPACE_MB').max * MB, 0);
    const people = live.reduce((sum, o) => sum + o.members.active, 0);
    const trialing = ORGS.filter((o) => o.subscription.status === 'TRIALING');
    const finished = ORGS.filter((o) => o.subscription.trialStartDate && o.subscription.status !== 'TRIALING');
    const converted = finished.filter(isPaying);

    const attention = [];
    ORGS.forEach((o) => {
      const fill = use(o, 'AVAILABLE_SPACE_MB').used / use(o, 'AVAILABLE_SPACE_MB').max;
      const st = o.subscription.status;
      const d = (iso) => new Date(iso).toLocaleDateString('ru-RU');
      if (o.retention) attention.push({ id: o.id, title: o.title, plan: o.plan.name, severity: 4, reason: 'удаление данных ' + d(o.retention.deadlineAt) });
      else if (st === 'UNPAID') attention.push({ id: o.id, title: o.title, plan: o.plan.name, severity: 3, reason: 'триал кончился, не оплачено' });
      else if (fill > 0.92) attention.push({ id: o.id, title: o.title, plan: o.plan.name, severity: 2, reason: 'место ' + Math.round(fill * 100) + '% — упрётся в лимит' });
      else if (st === 'TRIALING' && (new Date(o.subscription.trialEndDate) - TODAY) / DAY <= 3)
        attention.push({ id: o.id, title: o.title, plan: o.plan.name, severity: 1, reason: 'триал кончается ' + d(o.subscription.trialEndDate) });
    });
    attention.sort((a, b) => b.severity - a.severity);

    const byStorage = [...live].sort((a, b) => use(b, 'AVAILABLE_SPACE_MB').used - use(a, 'AVAILABLE_SPACE_MB').used);
    const byComments = [...live].sort((a, b) => b.comments - a.comments);

    return wait({
      generatedAt: new Date().toISOString(),
      days,
      tiles: {
        workspacesLive: live.length,
        workspacesTotal: ORGS.length,
        workspacesAdded: sum(cur, 'workspaces'),
        workspacesAddedPrev: sum(prev, 'workspaces'),
        people,
        peopleAdded: sum(cur, 'users'),
        peopleAddedPrev: sum(prev, 'users'),
        paying: pay.length,
        monthlyRevenue: pay.reduce((s2, o) => s2 + o.monthlyRevenue, 0),
        usedBytes: Math.round(usedBytes),
        limitBytes: Math.round(limitBytes),
        comments: sum(cur, 'comments'),
        commentsPrev: sum(prev, 'comments'),
      },
      subscriptionsByStatus: ['TRIALING', 'ACTIVE', 'UNPAID', 'EXPIRED', 'RETENTION'].map((status) => ({
        status,
        count: status === 'RETENTION'
          ? ORGS.filter((o) => o.retention).length
          : ORGS.filter((o) => o.subscription.status === status && !o.retention).length,
      })).filter((x) => x.count),
      trials: {
        running: trialing.length,
        endingThisWeek: trialing.filter((o) => (new Date(o.subscription.trialEndDate) - TODAY) / DAY <= 7).length,
        conversion: finished.length ? converted.length / finished.length : null,
        converted: converted.length,
        finished: finished.length,
        startedInPeriod: sum(cur, 'trials'),
        startedPrevPeriod: sum(prev, 'trials'),
      },
      averages: {
        peoplePerWorkspace: people / live.length,
        bytesPerWorkspace: usedBytes / live.length,
        fillRate: usedBytes / limitBytes,
        projectsPerWorkspace: live.reduce((s2, o) => s2 + o.projects, 0) / live.length,
        commentsPerDayPerWorkspace: sum(cur, 'comments') / days / live.length,
      },
      attention: attention.slice(0, 8),
      topByStorage: byStorage.slice(0, 6).map((o) => workspaceView(o)),
      topByComments: byComments.slice(0, 6).map((o) => workspaceView(o)),
    });
  },

  async series({ days = 30, metric = 'comments' }) {
    const rows = rangeDays(days);
    return wait(rows.map((r) => ({
      date: r.date.toISOString().slice(0, 10),
      value: r[metric] || 0,
      partial: !!r.partial,
    })));
  },

  async workspaces({ status = 'all', planId = 'all', q = '', sort = 'storage', dir = 'desc', page = 0, size = 50 } = {}) {
    let rows = ORGS.filter((o) => {
      if (planId !== 'all' && String(o.plan.id) !== String(planId)) return false;
      const fill = use(o, 'AVAILABLE_SPACE_MB').used / use(o, 'AVAILABLE_SPACE_MB').max;
      if (status === 'full') return fill > 0.8;
      if (status === 'soon') return o.subscription.status === 'TRIALING' && (new Date(o.subscription.trialEndDate) - TODAY) / DAY <= 7;
      if (status === 'RETENTION') return !!o.retention;
      if (status !== 'all') return o.subscription.status === status;
      return true;
    });
    if (q) {
      const needle = q.toLowerCase();
      rows = rows.filter((o) => o.title.toLowerCase().includes(needle) || o.owners.join(' ').includes(needle));
    }
    const key = {
      title: (o) => o.title,
      members: (o) => o.members.active,
      storage: (o) => use(o, 'AVAILABLE_SPACE_MB').used / use(o, 'AVAILABLE_SPACE_MB').max,
      projects: (o) => o.projects,
      videos: (o) => o.videos,
      comments: (o) => o.comments,
      revenue: (o) => money(o),
      activity: (o) => new Date(o.lastActivityAt),
    }[sort] || ((o) => o.videos);
    const factor = dir === 'asc' ? 1 : -1;
    rows.sort((a, b) => {
      const x = key(a); const y = key(b);
      return (typeof x === 'string' ? x.localeCompare(y) : x - y) * factor;
    });

    const items = rows.slice(page * size, (page + 1) * size).map((o) => workspaceView(o));
    return wait({
      items,
      page,
      size,
      total: rows.length,
      totals: {
        workspaces: rows.length,
        people: rows.reduce((s2, o) => s2 + o.members.active, 0),
        sizeBytes: Math.round(rows.reduce((s2, o) => s2 + use(o, 'AVAILABLE_SPACE_MB').used * MB, 0)),
        monthlyRevenue: rows.reduce((s2, o) => s2 + money(o), 0),
      },
    });
  },

  async workspace(id) {
    const o = ORGS.find((x) => String(x.id) === String(id));
    if (!o) { const e = new Error('Пространство не найдено'); e.status = 404; throw e; }
    return wait(workspaceView(o, true));
  },

  async workspaceSeries(id, { days = 60 }) {
    const o = ORGS.find((x) => String(x.id) === String(id));
    const share = o.comments / Math.max(1, ORGS.reduce((s2, x) => s2 + x.comments, 0));
    return wait(rangeDays(days).map((d) => ({
      date: d.date.toISOString().slice(0, 10),
      value: Math.max(0, Math.round(d.comments * share * (0.6 + rnd() * 0.8))),
      partial: !!d.partial,
    })));
  },

  async users({ filter = 'all', q = '', page = 0, size = 50 } = {}) {
    let rows = USERS.filter((u) => {
      if (filter === 'owner') return u.organizations.some((r) => r.role === 'OWNER');
      if (filter === 'multi') return u.organizations.length > 1;
      if (filter === 'pending') return u.organizations.some((r) => r.roleStatus === 'PENDING');
      if (filter === 'blocked') return u.blocked;
      if (filter === 'idle') return (TODAY - new Date(u.lastSeenAt)) / DAY > 30;
      return true;
    });
    if (q) {
      const needle = q.toLowerCase();
      rows = rows.filter((u) => (u.email + u.firstName + u.lastName + u.organizations.map((r) => r.title).join(' ')).toLowerCase().includes(needle));
    }
    rows.sort((a, b) => new Date(b.lastSeenAt) - new Date(a.lastSeenAt));
    return wait({
      items: rows.slice(page * size, (page + 1) * size).map(userView),
      page,
      size,
      total: rows.length,
      grandTotal: USERS.length,
    });
  },

  async user(id) {
    const u = USERS.find((x) => String(x.id) === String(id));
    if (!u) { const e = new Error('Пользователь не найден'); e.status = 404; throw e; }
    return wait(userView(u));
  },

  async revenue() {
    const pay = ORGS.filter(isPaying);
    const live = ORGS.filter(isLive);
    const revenue = pay.reduce((s2, o) => s2 + o.monthlyRevenue, 0);
    const byPlan = PLANS.map((p) => ({
      planId: p.id, plan: p.name, published: p.published,
      monthlyRevenue: pay.filter((o) => o.plan.id === p.id).reduce((s2, o) => s2 + o.monthlyRevenue, 0),
    })).filter((x) => x.monthlyRevenue);
    return wait({
      monthlyRevenue: revenue,
      payingWorkspaces: pay.length,
      averageCheck: pay.length ? Math.round(revenue / pay.length) : 0,
      freeActive: ORGS.filter((o) => o.subscription.status === 'ACTIVE' && o.monthlyRevenue === 0).length,
      grantedWithoutPayment: ORGS.filter(isGranted).length,
      grantedListPrice: ORGS.filter(isGranted).reduce((s2, o) => s2 + o.monthlyRevenue, 0),
      addonsRevenue: pay.reduce((s2, o) => s2 + o.addons.seats * 999 + o.addons.space10 * 299, 0),
      addonsWorkspaces: pay.filter((o) => o.addons.seats || o.addons.space10).length,
      churned: ORGS.filter((o) => o.retention || ['EXPIRED', 'CANCELLED'].includes(o.subscription.status)).length,
      totalWorkspaces: ORGS.length,
      annualPayers: pay.filter((o) => o.subscription.annual).length,
      monthlyPayers: pay.filter((o) => !o.subscription.annual).length,
      byPlan,
      countsByPlan: PLANS.map((p) => ({
        planId: p.id, plan: p.name, published: p.published,
        workspaces: live.filter((o) => o.plan.id === p.id).length,
      })).filter((x) => x.workspaces),
    });
  },

  async payments({ days = 30 } = {}) {
    const paid = sum(rangeDays(days), 'payments');
    const failed = Math.round(paid * 0.11) + 3;
    return wait({
      paid,
      failed,
      pending: 2,
      refunded: 0,
      paidAmount: paid * 4380,
      averagePayment: 4380,
      failureRate: paid + failed ? failed / (paid + failed) : null,
      reasons: [
        { reason: 'недостаточно средств', count: Math.round(failed * 0.5) },
        { reason: 'отказ банка-эмитента', count: Math.round(failed * 0.3) },
        { reason: 'истёк срок карты', count: failed - Math.round(failed * 0.5) - Math.round(failed * 0.3) },
      ].filter((x) => x.count > 0),
    });
  },

  async trialCohorts() {
    const map = new Map();
    ORGS.forEach((o) => {
      if (!o.subscription.trialStartDate) return;
      const d = new Date(o.subscription.trialStartDate);
      // Собираем дату вручную: toISOString() увёл бы первое число месяца на предыдущее.
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
      if (!map.has(key)) map.set(key, { month: key, started: 0, paid: 0, running: 0 });
      const c = map.get(key);
      c.started++;
      if (isPaying(o)) c.paid++;
      else if (o.subscription.status === 'TRIALING') c.running++;
    });
    return wait([...map.values()]
      .sort((a, b) => a.month.localeCompare(b.month))
      .slice(-10)
      .map((c) => {
        const finished = c.started - c.running;
        return { ...c, lost: finished - c.paid, conversion: finished ? c.paid / finished : null };
      }));
  },

  async renewals({ days = 14 } = {}) {
    return wait(ORGS
      .filter((o) => isPaying(o) && o.subscription.renewAt && (new Date(o.subscription.renewAt) - TODAY) / DAY <= days)
      .sort((a, b) => new Date(a.subscription.renewAt) - new Date(b.subscription.renewAt))
      .map((o) => ({
        workspaceId: o.id,
        title: o.title,
        plan: o.plan.name,
        annual: o.subscription.annual,
        date: o.subscription.renewAt.slice(0, 10),
        amount: o.monthlyRevenue,
        autoRenew: true,
      })));
  },

  async content({ days = 30 } = {}) {
    const cur = rangeDays(days);
    const prev = prevDays(days);
    const live = ORGS.filter(isLive);
    const videos = ORGS.reduce((s2, o) => s2 + o.videos, 0);
    const durationSec = ORGS.reduce((s2, o) => s2 + o.durationSec, 0);
    const comments = ORGS.reduce((s2, o) => s2 + o.comments, 0);
    const sizeBytes = Math.round(ORGS.reduce((s2, o) => s2 + use(o, 'AVAILABLE_SPACE_MB').used * MB, 0));

    const acc = {};
    rangeDays(Math.min(days, 90)).forEach((d) => {
      const weekday = d.date.getDay() === 0 ? 7 : d.date.getDay();
      acc[weekday] = acc[weekday] || [0, 0];
      acc[weekday][0] += d.comments;
      acc[weekday][1] += 1;
    });

    return wait({
      period: {
        days,
        videos: sum(cur, 'videos'), videosPrev: sum(prev, 'videos'),
        durationSec: sum(cur, 'durationSec'), durationSecPrev: sum(prev, 'durationSec'),
        comments: sum(cur, 'comments'), commentsPrev: sum(prev, 'comments'),
      },
      totals: { videos, durationSec, comments, sizeBytes },
      averages: {
        videosPerWorkspace: videos / live.length,
        secondsPerVideo: durationSec / Math.max(1, videos),
        commentsPerVideo: comments / Math.max(1, videos),
        bytesPerVideo: sizeBytes / Math.max(1, videos),
      },
      byWeekday: [1, 2, 3, 4, 5, 6, 7].map((weekday) => ({
        weekday,
        comments: acc[weekday] ? acc[weekday][0] / acc[weekday][1] : 0,
      })),
      topByDuration: [...ORGS].sort((a, b) => b.durationSec - a.durationSec).slice(0, 8).map((o) => workspaceView(o)),
    });
  },

  /** Существующий /api/v1/admin/plan: цена и лимиты лежат внутри версий. */
  async plans() {
    return wait(PLANS.map((p) => ({
      id: p.id,
      name: p.name,
      description: p.hiddenNote || null,
      published: p.published,
      isDeleted: false,
      isDefault: p.name === 'База',
      prices: [{ id: p.id, periodValue: 1, periodUnit: 'MONTH', price: p.price, currency: 'RUB', trialDays: p.trialDays }],
      attributes: [
        { code: 'available_user_count', value: p.users, unlimited: false },
        { code: 'available_space_mb', value: p.spaceMb, unlimited: false },
        { code: 'available_project_count', value: p.projects, unlimited: p.projects === 0 },
      ],
    })));
  },

  async publicPlans() {
    return wait(PLANS.filter((p) => p.published).map((p) => ({ id: p.id, name: p.name })));
  },

  /* Действия в режиме заглушек ничего не меняют — только отвечают успехом. */
  actions: {
    async assignPlan() { return wait(null, 600); },
    async setSubscriptionStatus() { return wait(null, 500); },
    async deleteSubscription() { return wait(null, 500); },
    async blockUser() { return wait(null, 400); },
    async unblockUser() { return wait(null, 400); },
    async resetTrial() { return wait(null, 400); },
  },

  async runJob() { return wait(null, 700); },
};
